import styled from 'styled-components';
import theme from 'styled-theming';
import { rem, rgba, cssVar } from 'polished';
import { prefix } from '../../tools/settings';
var height = theme('size', {
  small: rem(28),
  medium: rem(44)
});
var width = theme('size', {
  small: rem(28),
  medium: rem(44)
});
var border = theme.variants('mode', 'variant', {
  primary: {
    light: 'none',
    grey: 'none',
    dark: 'none'
  },
  secondary: {
    light: '2px solid var(--dentsu-color-b550)',
    grey: '2px solid var(--dentsu-color-b550)',
    dark: '2px solid var(--dentsu-color-white)'
  },
  tertiary: {
    light: 'none',
    grey: 'none',
    dark: 'none'
  },
  ghost: {
    light: 'none',
    grey: 'none',
    dark: 'none'
  }
});
var borderHover = theme.variants('mode', 'variant', {
  primary: {
    light: 'none',
    grey: 'none',
    dark: 'none'
  },
  secondary: {
    light: '2px solid var(--dentsu-color-b600)',
    grey: '2px solid var(--dentsu-color-b600)',
    dark: '2px solid var(--dentsu-color-white)'
  },
  tertiary: {
    light: 'none',
    grey: 'none',
    dark: 'none'
  },
  ghost: {
    light: 'none',
    grey: 'none',
    dark: 'none'
  }
});
var borderActive = theme.variants('mode', 'variant', {
  primary: {
    light: 'none',
    grey: 'none',
    dark: 'none'
  },
  secondary: {
    light: '2px solid var(--dentsu-color-b600)',
    grey: '2px solid var(--dentsu-color-b600)',
    dark: '2px solid var(--dentsu-color-white)'
  },
  tertiary: {
    light: 'none',
    grey: 'none',
    dark: 'none'
  },
  ghost: {
    light: 'none',
    grey: 'none',
    dark: 'none'
  }
});
var bgBackground = theme.variants('mode', 'variant', {
  primary: {
    light: 'var(--dentsu-color-b500)',
    grey: 'var(--dentsu-color-b500)',
    dark: "var(--dentsu-color-white)"
  },
  secondary: {
    light: 'var(--dentsu-color-white)',
    grey: 'var(--dentsu-color-white)',
    dark: 'none'
  },
  tertiary: {
    light: 'var(--dentsu-color-n150)',
    grey: "var(--dentsu-color-white)",
    dark: rgba(cssVar('--dentsu-color-white', '#ffffff'), 0.3)
  },
  ghost: {
    light: 'none',
    grey: 'none',
    dark: 'none'
  }
});
var bgBackgroundHover = theme.variants('mode', 'variant', {
  primary: {
    light: 'var(--dentsu-color-b550)',
    grey: 'var(--dentsu-color-b550)',
    dark: 'var(--dentsu-color-white)'
  },
  secondary: {
    light: 'var(--dentsu-color-white)',
    grey: 'var(--dentsu-color-white)',
    dark: rgba(cssVar('--dentsu-color-white', '#ffffff'), 0.05)
  },
  tertiary: {
    light: 'var(--dentsu-color-n200)',
    grey: 'var(--dentsu-color-n200)',
    dark: rgba(cssVar('--dentsu-color-white', '#ffffff'), 0.2)
  },
  ghost: {
    light: 'var(--dentsu-color-n100)',
    grey: 'var(--dentsu-color-n100)',
    dark: rgba(cssVar('--dentsu-color-n100', '#ffffff'), 0.2)
  }
});
var bgBackgroundActive = theme.variants('mode', 'variant', {
  primary: {
    light: 'var(--dentsu-color-b600)',
    grey: 'var(--dentsu-color-b600)',
    dark: 'var(--dentsu-color-white)'
  },
  secondary: {
    light: 'var(--dentsu-color-white)',
    grey: 'var(--dentsu-color-white)',
    dark: rgba(cssVar('--dentsu-color-white', '#ffffff'), 0.1)
  },
  tertiary: {
    light: 'var(--dentsu-color-n250)',
    grey: 'var(--dentsu-color-n250)',
    dark: rgba(cssVar('--dentsu-color-white', '#ffffff'), 0.15)
  },
  ghost: {
    light: 'var(--dentsu-color-n100)',
    grey: 'var(--dentsu-color-n100)',
    dark: rgba(cssVar('--dentsu-color-n100', '#ffffff'), 0.15)
  }
});
var fontSize = theme('size', {
  small: rem(12),
  medium: rem(14)
});
var fontColor = theme.variants('mode', 'variant', {
  primary: {
    light: "var(--dentsu-color-white)",
    grey: "var(--dentsu-color-white)",
    dark: "var(--dentsu-color-b500)"
  },
  secondary: {
    light: "var(--dentsu-color-b550)",
    grey: "var(--dentsu-color-b550)",
    dark: "var(--dentsu-color-white)"
  },
  tertiary: {
    light: "var(--dentsu-color-b550)",
    grey: "var(--dentsu-color-b550)",
    dark: "var(--dentsu-color-white)"
  },
  ghost: {
    light: "var(--dentsu-color-b550)",
    grey: "var(--dentsu-color-b550)",
    dark: "var(--dentsu-color-white)"
  }
});
var fontColorHover = theme.variants('mode', 'variant', {
  primary: {
    light: "var(--dentsu-color-white)",
    grey: "var(--dentsu-color-white)",
    dark: "var(--dentsu-color-b500)"
  },
  secondary: {
    light: "var(--dentsu-color-b550)",
    grey: "var(--dentsu-color-b550)",
    dark: "var(--dentsu-color-white)"
  },
  tertiary: {
    light: "var(--dentsu-color-b550)",
    grey: "var(--dentsu-color-b550)",
    dark: "var(--dentsu-color-white)"
  },
  ghost: {
    light: "var(--dentsu-color-b550)",
    grey: "var(--dentsu-color-b550)",
    dark: "var(--dentsu-color-white)"
  }
});
var fontColorActive = theme.variants('mode', 'variant', {
  primary: {
    light: "var(--dentsu-color-white)",
    grey: "var(--dentsu-color-white)",
    dark: "var(--dentsu-color-b500)"
  },
  secondary: {
    light: "var(--dentsu-color-b550)",
    grey: "var(--dentsu-color-b550)",
    dark: "var(--dentsu-color-white)"
  },
  tertiary: {
    light: "var(--dentsu-color-b550)",
    grey: "var(--dentsu-color-b550)",
    dark: "var(--dentsu-color-white)"
  },
  ghost: {
    light: "var(--dentsu-color-b550)",
    grey: "var(--dentsu-color-b550)",
    dark: "var(--dentsu-color-white)"
  }
});
export var StyledIconButton = styled.button.withConfig({
  displayName: "IconButtonstyles__StyledIconButton",
  componentId: "sc-14bmv2m-0"
})(["cursor:pointer;-webkit-appearance:none;user-select:none;transition:background var(--dentsu-motion-duration-fast) var(--dentsu-motion-easing-standard);position:relative;border-radius:var(--dentsu-radius-4);display:inline-flex;align-items:center;padding:0;line-height:1;z-index:0;justify-content:center;border:none;text-decoration:none;vertical-align:top;color:", ";width:", ";height:", ";box-shadow:none;border:", ";background:", ";&:hover:not([disabled]){color:", ";background:", ";border:", ";}&:active:not([disabled]){color:", ";background:", ";border:", ";}&:focus{outline:none;box-shadow:0 0 0 ", " ", ";}&:disabled{cursor:", ";box-shadow:none;opacity:var(--dentsu-opacity-40);}.", "-icon-button__icon{height:", ";width:", ";display:inline-block;vertical-align:top;position:relative;z-index:2;.", "-icon{vertical-align:top;}}.", "-spinner{position:relative;z-index:2;}"], fontColor, width, height, border, bgBackground, fontColorHover, bgBackgroundHover, borderHover, fontColorActive, bgBackgroundActive, borderActive, rem(4), rgba(cssVar('--dentsu-color-p150', '#cebaed'), 0.6), function (props) {
  return props.isLoading ? 'wait' : 'not-allowed';
}, prefix, fontSize, fontSize, prefix, prefix);